<div class="ratio-wrapper">
  <div class="main-container">
    <img osnSharedUseAsPicture [imgQuery]="imgQuery" [src]="fallbackUrl" alt="background image" class="background-image" />
    <div class="content-container" [class.align-right]="vm.layout === 'RIGHT_ALIGNED'">
      <div>
        <h1 class="title" [class.title-style-light]="vm.titleStyle === 'LIGHT'">{{ vm.title }}</h1>
        <p class="subtitle" [class.description-style-light]="vm.descriptionStyle === 'LIGHT'">{{ vm.description }}</p>
      </div>
      <button (click)="onRedeemSignupClick()" class="marketing-button">
        {{ primaryButtonText }}
      </button>
    </div>
  </div>
</div>
